export const breakpoints = {
    desktop: 992,
    tablet: 768,
};
